export class ProductLiteModel {
    public id: number;
    public productId: number;
    public article: string;
    public price: number;
    public unitId: number;
    public articleNumber: string;
    public quantity: number;
    public addedFromPlanner: boolean;
    public discount: number;
    public priceWithoutDiscount: number;
    public index: number;
    public billQuantity: number;
}